import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { actions as notifications } from '@saucelabs/sl-container-notifications';

import * as globalApi from '../../api';
import api from './api';
import types from './types';

// payload: Immutable.Set of the composite IDs of starred devices
// meta: { added: DeviceDescriptor, removed: DeviceDescriptor }
//   should not have added AND removed, as it describes the starring action
//   i.e. added for when the user is starring a device, removed for unstarring
const updateStarredRealDevices = createApiAction(
  types.UPDATE_STARRED_REAL_DEVICES,
  (payload, { added, removed }, dispatch) => globalApi.putMetadata('manual', 'real_devices_starred_by_composite_id', payload)
    .catch((error) => {
      const starOrUnstarText = added ? `Pinning the ${added.get('name')}` : `Unpinning the ${removed.get('name')}`;
      const errorMessage = `Sorry! ${starOrUnstarText} didn’t seem to work. Please try again later.`;
      dispatch(notifications.notifyDanger(errorMessage));
      throw error;
    }),
);

const selectMobileSelectionCurrentView = createAction(
  types.SET_MOBILE_SELECTION_CURRENT_VIEW,
);
const updateMobileSelectionFilter = createAction(types.UPDATE_MOBILE_SELECTION_FILTER);
// in opposite to updateMobileSelectionFilter it's accepts an array of filters
// TODO: enhance updateMobileSelectionFilter to be able to do the same
const setMobileSelectionFilters = createAction(types.SET_MOBILE_SELECTION_FILTERS);
const clearMobileSelectionFilter = createAction(types.CLEAR_MOBILE_SELECTION_FILTER);
const updateMobileSelectionSearchTerm = createAction(
  types.UPDATE_MOBILE_SELECTION_SEARCH_TERM,
);

const sortDevices = createAction(types.SORT_DEVICES);

const fetchMobileDevices = createApiAction(
  types.MOBILE_DEVICES_FETCH,
  (payload) => api.fetchFilteredDevices(payload),
  { meta: { skipErrorPage: true } },
);

const fetchAvailableDeviceIds = createApiAction(
  types.MOBILE_AVAILABLE_DEVICE_IDS_FETCH,
  () => api.fetchAllAvailableDeviceIds(),
  { meta: { skipErrorPage: true } },
);

const fetchMobileSessionAvailable = createApiAction(
  types.MOBILE_SESSION_AVAILABLE_FETCH,
  () => api.fetchSessionAvailable(),
  { meta: { skipErrorPage: true } },
);

const fetchDeviceState = (dispatch) => {
  dispatch(fetchAvailableDeviceIds());
  dispatch(fetchMobileSessionAvailable());
};

let realDevicePollingTimerId;
const pollDeviceState = () => (dispatch) => {
  const isPollingInProgress = !!realDevicePollingTimerId;

  fetchDeviceState(dispatch);
  if (isPollingInProgress) {
    clearInterval(realDevicePollingTimerId);
  }
  realDevicePollingTimerId = setInterval(fetchDeviceState.bind(this, dispatch), 3000);

  return isPollingInProgress;
};

const startFetchingMobileRealDeviceData = () => (dispatch) => {
  dispatch(fetchMobileDevices());
  dispatch(pollDeviceState());
};

const stopFetchingMobileRealDeviceData = () => () => {
  clearInterval(realDevicePollingTimerId);
  realDevicePollingTimerId = null;
};

export default {
  clearMobileSelectionFilter,
  fetchMobileSessionAvailable,
  pollDeviceState,
  selectMobileSelectionCurrentView,
  setMobileSelectionFilters,
  sortDevices,
  startFetchingMobileRealDeviceData,
  stopFetchingMobileRealDeviceData,
  updateMobileSelectionFilter,
  updateMobileSelectionSearchTerm,
  updateStarredRealDevices,
};

export {
  fetchAvailableDeviceIds,
  fetchDeviceState,
  fetchMobileDevices,
};
